import script from "./Exhibit.vue?vue&type=script&setup=true&lang=js"
export * from "./Exhibit.vue?vue&type=script&setup=true&lang=js"

import "./Exhibit.vue?vue&type=style&index=0&id=5edd39d9&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5edd39d9"]])

export default __exports__